
import { useState } from 'react';
import ConsultationPopup from '../../../components/feature/ConsultationPopup';

export default function CTASection() {
  const [showConsultationPopup, setShowConsultationPopup] = useState(false);

  return (
    <>
      <section className="py-20 bg-gradient-to-r from-blue-600 to-blue-800">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
            Let's Build Your Next E-commerce Success Story
          </h2>
          <p className="text-xl text-blue-100 mb-8 max-w-3xl mx-auto">
            Ready to scale your business with proven marketing strategies? Get a free consultation and discover how we can help you achieve your growth goals.
          </p>
          <button
            onClick={() => setShowConsultationPopup(true)}
            className="bg-white text-blue-600 px-8 py-4 rounded-lg text-lg font-semibold hover:bg-gray-100 transition-colors shadow-lg hover:shadow-xl transform hover:-translate-y-1 whitespace-nowrap"
          >
            Get Started Today
          </button>
        </div>
      </section>

      {/* Consultation Popup */}
      <ConsultationPopup 
        isOpen={showConsultationPopup}
        onClose={() => setShowConsultationPopup(false)}
      />
    </>
  );
}
